/**
 * 10.9ET — CAIXA DE CONFIRMACAO DE COMPRA reaproveitavel ("Comprar X por Y?" · Nao / Sim).
 * Mesmo visual das confirmacoes da Loja e do VIP (.vip-confirm). Abre por cima de `host`
 * (a tela que esta aberta); tocar fora da caixa ou em "Nao" fecha sem gastar nada.
 */
import { i18n } from "../i18n/i18n";

const esc = (s: string): string => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function confirmBuy(host: HTMLElement, text: string, onYes: () => void): void {
  host.querySelector(":scope > .vip-confirm")?.remove();
  const box = document.createElement("div");
  box.className = "vip-confirm";
  box.innerHTML = `<div class="vip-confirm-box">
      <div class="vip-confirm-title">${esc(i18n.t("vip.confirmTitle"))}</div>
      <div class="vip-confirm-text">${esc(text)}</div>
      <div class="vip-confirm-btns">
        <button class="btn" data-a="no">${esc(i18n.t("vip.confirmNo"))}</button>
        <button class="btn primary" data-a="yes">${esc(i18n.t("vip.confirmYes"))}</button>
      </div>
    </div>`;
  box.addEventListener("click", (e) => { e.stopPropagation(); if (e.target === box) box.remove(); });
  box.querySelector('[data-a="no"]')!.addEventListener("click", () => box.remove());
  box.querySelector('[data-a="yes"]')!.addEventListener("click", () => { box.remove(); onYes(); });
  host.appendChild(box);
}
